<template>
	<div class="co-contacts-section-content" v-if="selector || editing">
		<v-layout row wrap align-center v-if="selector">
			<v-flex xs12 sm11 :pb-0="$vuetify.breakpoint.xs">
				<v-radio :value="address.idx" :disabled="!address.can_be_used" :off-icon="offIcon" @change="doTracking()" v-bind="ADAattr('label', _ADAlabel)">
					<template v-slot:label>
						<div class="co-contacts-address-card" :class="{'grey--text': !address.can_be_used}">
							<div class="co-contacts-address-card-info" v-html="_label"></div>
						</div>
					</template>
				</v-radio>
			</v-flex>
			<v-flex xs12 sm1 :pt-0="$vuetify.breakpoint.xs">
				<div v-if="address.id > 0 && address.can_be_used">
					<a ref="edit" href="#" @click.prevent="address.edit" :style="{'margin-left': $vuetify.breakpoint.xs ? '32px' : 0}" v-bind="[ADAattr('focus', selected), ADAattr('control', `ada-ea-${address.idx}`, 'Edit selected shipping address')]">Edit</a>
				</div>
			</v-flex>
		</v-layout>
		<template v-if="editing">
			<div class="pb-2 subheading grey--text" v-if="!selector && label">
				<strong>{{ label }}</strong>
			</div>
			<add-edit-shipping-address-form
					ref="form"
					:address="address"
					:disable_apo_states="disable_apo_states"
					:only-phone-editable="is_campus"
					:show-name-field="!is_campus"
					:show-label-field="address.id === 0"
					:id="`ada-ea-${address.idx}`"
					@editing-address="address.onEdit"
			/>
			<div>
				<v-btn @click="address.save($refs.form)" class="ml-0" :loading="saving" v-if="!this.$globs['is_vie']" v-bind="ADAattr('button-readonly', saving, 'Save changes')">Save</v-btn>
				<v-btn @click="address.cancel(); ADAfocus($refs.edit)" v-if="address.id > 0" v-bind="ADAattr('label', 'Discard changes')">Cancel</v-btn>
			</div>
		</template>
	</div>
</template>

<script>
	import AddEditShippingAddressForm from './AddEditShippingAddressForm';
	import {formatAddressLabel, formatAddress} from './../includes/Miscellaneous';

	export default {
		components: {
			AddEditShippingAddressForm,
		},

		props: {
			address: Object,

			selector: {
				default: true,
			},

			selected: {
				type: Boolean,
				default: false,
			},

			editing: {
				type: Boolean,
				default: false,
			},

			saving: {
				type: Boolean,
				default: false,
			},

			disable_apo_states: {
				type: Boolean,
				default: false,
			},

			label: String,

			offIcon: {
				type: String,
				default: 'radio_button_unchecked',
			},
		},

		computed: {
			is_campus() {
				return this.address.campus_address === true || this.address.source === 'campus_dropdown';
			},

			_label() {
				return this.label || (
					`<strong>${this.formatAddressLabel(this.address)}</strong> ${this.formatAddress(this.address, ' ', 'distinct')}`
				);
			},

			_ADAlabel() {
				return this.label || (
					`${this.is_campus ? 'Ship to campus' : 'Ship to home'}, address label: ${this.formatAddressLabel(this.address)}, address: ${this.formatAddress(this.address, ' ', 'distinct')}`
				);
			},
		},

		methods: {
			formatAddressLabel,
			formatAddress,

			doTracking() {
				if (this.address.id > 0 && typeof sendGAAction === 'function') {
					sendGAAction('Checkout: selected one of saved addresses');
				}
			},
		},
	};
</script>

<style scoped lang="less">
	.co-contacts-section-content {
		padding: 15px 0px;
		border-bottom: 1px solid #e0e0e0;

		&[class$="--text"] {
			/deep/ .v-icon {
				color: inherit;
			}
		}

		/deep/ label.v-label {
			flex: 1;
		}

		/deep/ .co-contacts-address-card {
			width: 100%;
			display: flex;
			justify-content: space-between;

			@media screen and (max-width: 600px) {
				flex-direction: column;
			}

			.co-contacts-address-card-info {
				margin-right: 10px;
			}
		}
	}
</style>
